/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes[ErrorCodes["E0001"] = 0] = "E0001";
    ErrorCodes[ErrorCodes["E0002"] = 1] = "E0002";
    ErrorCodes[ErrorCodes["E0003"] = 2] = "E0003";
    ErrorCodes[ErrorCodes["E0004"] = 3] = "E0004";
    ErrorCodes[ErrorCodes["E0005"] = 4] = "E0005";
    ErrorCodes[ErrorCodes["E0006"] = 5] = "E0006";
    ErrorCodes[ErrorCodes["E0007"] = 6] = "E0007";
    ErrorCodes[ErrorCodes["E0008"] = 7] = "E0008";
})(ErrorCodes || (ErrorCodes = {}));
var ParseError = /** @class */ (function (_super) {
    __extends(ParseError, _super);
    function ParseError(code) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _this = _super.call(this) || this;
        _this.code = code;
        _this.args = args;
        _this.message = getErrorMessage(code, args);
        return _this;
    }
    return ParseError;
}(Error));
function getErrorMessage(code, args) {
    switch (code) {
        case ErrorCodes.E0001:
            return 'Generic error';
        case ErrorCodes.E0002: {
            var _a = __read(args, 1), token = _a[0];
            return "Expected token: \"".concat(token, "\"");
        }
        case ErrorCodes.E0003: {
            var _b = __read(args, 1), range = _b[0];
            return "Expected a character from range: \"".concat(range, "\"");
        }
        case ErrorCodes.E0004: {
            var _c = __read(args, 1), char = _c[0];
            return "Unknown escape sequence: \\".concat(char, ".");
        }
        case ErrorCodes.E0005: {
            var _d = __read(args, 1), char = _d[0];
            return "Invalid Unicode escape sequence: \\u".concat(char, ".");
        }
        case ErrorCodes.E0006: {
            var _e = __read(args, 1), tagName = _e[0];
            return "Tag \"".concat(tagName, "\" does not exist on the dictionary");
        }
        case ErrorCodes.E0007: {
            var _f = __read(args, 2), tagName = _f[0], tagValue = _f[1];
            return "Don't know how to parse tag \"".concat(tagName, "\": \"").concat(tagValue, "\".");
        }
        case ErrorCodes.E0008: {
            return "Unable to find 'num' argument for plural tag.";
        }
        default:
            return String(code);
    }
}

var MessageTextElement = /** @class */ (function () {
    function MessageTextElement(str) {
        this.type = 'messageTextElement';
        this.value = str;
    }
    return MessageTextElement;
}());
var OptionalFormatPattern = /** @class */ (function () {
    function OptionalFormatPattern(selector, value) {
        this.type = 'optionalFormatPattern';
        this.selector = selector;
        this.value = value;
    }
    return OptionalFormatPattern;
}());
var PluralFormat = /** @class */ (function () {
    function PluralFormat(options, offset, ordinal) {
        if (offset === void 0) { offset = 0; }
        if (ordinal === void 0) { ordinal = false; }
        this.options = options;
        this.offset = offset;
        this.ordinal = ordinal;
        this.type = 'pluralFormat';
    }
    return PluralFormat;
}());
var SelectFormat = /** @class */ (function () {
    function SelectFormat(options) {
        this.options = options;
        this.type = 'selectFormat';
    }
    return SelectFormat;
}());
var ArgumentElement = /** @class */ (function () {
    function ArgumentElement(argName, format, meta) {
        this.type = 'argumentElement';
        this.id = argName;
        this.format = format;
        this.meta = meta;
    }
    return ArgumentElement;
}());
var MessageFormatRoot = /** @class */ (function () {
    function MessageFormatRoot(elements) {
        this.type = 'messageFormatPattern';
        this.elements = elements;
    }
    return MessageFormatRoot;
}());

var ParserStream = /** @class */ (function () {
    function ParserStream(str) {
        this.index = 0;
        this.peekOffset = 0;
        this.str = str;
        this.firstNumArg = '';
    }
    ParserStream.prototype.charAt = function (offset) {
        // When the cursor is at CRLF, return LF but don't move the cursor.
        // The cursor still points to the EOL position, which in this case is the
        // beginning of the compound CRLF sequence. This ensures slices of
        // [inclusive, exclusive) continue to work properly.
        if (this.str[offset] === '\r' && this.str[offset + 1] === '\n') {
            return '\n';
        }
        return this.str[offset];
    };
    ParserStream.prototype.currentChar = function () {
        return this.charAt(this.index);
    };
    ParserStream.prototype.currentPeek = function () {
        return this.charAt(this.index + this.peekOffset);
    };
    ParserStream.prototype.next = function () {
        this.peekOffset = 0;
        // Skip over the CRLF as if it was a single character.
        if (this.str[this.index] === '\r' && this.str[this.index + 1] === '\n') {
            this.index += 1;
        }
        this.index += 1;
        return this.str[this.index];
    };
    ParserStream.prototype.peek = function () {
        // Skip over the CRLF as if it was a single character.
        if (this.str[this.index + this.peekOffset] === '\r' &&
            this.str[this.index + this.peekOffset + 1] === '\n') {
            this.peekOffset += 1;
        }
        this.peekOffset += 1;
        return this.str[this.index + this.peekOffset];
    };
    ParserStream.prototype.resetPeek = function (offset) {
        if (offset === void 0) { offset = 0; }
        this.peekOffset = offset;
    };
    ParserStream.prototype.skipToPeek = function () {
        this.index += this.peekOffset;
        this.peekOffset = 0;
    };
    return ParserStream;
}());
var EOL = '\n';
var EOF = undefined;
var LingoParserStream = /** @class */ (function (_super) {
    __extends(LingoParserStream, _super);
    function LingoParserStream() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LingoParserStream.prototype.skipBlankInline = function () {
        while (this.currentChar() === ' ') {
            this.next();
        }
    };
    LingoParserStream.prototype.peekBlankInline = function () {
        while (this.currentPeek() === ' ') {
            this.peek();
        }
    };
    LingoParserStream.prototype.skipBlankBlock = function () {
        // This logic looks wrong
        var lineCount = 0;
        while (true) {
            this.peekBlankInline();
            if (this.currentPeek() === EOL) {
                this.next();
                lineCount += 1;
            }
            else {
                this.resetPeek();
                return lineCount;
            }
        }
    };
    LingoParserStream.prototype.peekBlankBlock = function () {
        // This logic looks wrong
        while (true) {
            var lineStart = this.peekOffset;
            this.peekBlankInline();
            if (this.currentPeek() === EOL) {
                this.peek();
            }
            else {
                this.resetPeek(lineStart);
                break;
            }
        }
    };
    LingoParserStream.prototype.skipBlank = function () {
        while (this.currentChar() === ' ' || this.currentChar() === EOL) {
            this.next();
        }
    };
    LingoParserStream.prototype.peekBlank = function () {
        while (this.currentPeek() === ' ' || this.currentPeek() === EOL) {
            this.peek();
        }
    };
    LingoParserStream.prototype.expectChar = function (ch) {
        if (this.currentChar() === ch) {
            this.next();
            return true;
        }
        throw new ParseError(ErrorCodes.E0002, ch);
    };
    LingoParserStream.prototype.expectLineEnd = function () {
        if (this.currentChar() === EOF) {
            // EOF is a valid line end in Fluent.
            return true;
        }
        if (this.currentChar() === EOL) {
            this.next();
            return true;
        }
        // Unicode Character 'SYMBOL FOR NEWLINE' (U+2424)
        throw new ParseError(ErrorCodes.E0002, '\u2424');
    };
    LingoParserStream.prototype.takeChar = function (f) {
        var ch = this.currentChar();
        if (ch === EOF) {
            return EOF;
        }
        if (f(ch)) {
            this.next();
            return ch;
        }
        return null;
    };
    LingoParserStream.prototype.isCharIDStart = function (ch) {
        if (ch === EOF) {
            return false;
        }
        var cc = ch.charCodeAt(0);
        return ((cc >= 97 && cc <= 122) || // a-z
            (cc >= 65 && cc <= 90)); // A-Z
    };
    LingoParserStream.prototype.isIdentifierStart = function () {
        return this.isCharIDStart(this.currentPeek());
    };
    LingoParserStream.prototype.isNumberStart = function () {
        var ch = this.currentChar() === '-' ? this.peek() : this.currentChar();
        if (ch === EOF) {
            this.resetPeek();
            return false;
        }
        var cc = ch.charCodeAt(0);
        var isDigit = cc >= 48 && cc <= 57; // 0-9
        this.resetPeek();
        return isDigit;
    };
    LingoParserStream.prototype.takeIDStart = function () {
        if (this.isCharIDStart(this.currentChar())) {
            var ret = this.currentChar();
            this.next();
            return ret;
        }
        throw new ParseError(ErrorCodes.E0003, 'a-zA-Z');
    };
    LingoParserStream.prototype.takeIDChar = function () {
        var closure = function (ch) {
            var cc = ch.charCodeAt(0);
            return ((cc >= 97 && cc <= 122) || // a-z
                (cc >= 65 && cc <= 90) || // A-Z
                (cc >= 48 && cc <= 57) || // 0-9
                cc === 95 ||
                cc === 45); // _-
        };
        return this.takeChar(closure);
    };
    LingoParserStream.prototype.takeDigit = function () {
        var closure = function (ch) {
            var cc = ch.charCodeAt(0);
            return cc >= 48 && cc <= 57; // 0-9
        };
        return this.takeChar(closure);
    };
    LingoParserStream.prototype.takeHexDigit = function () {
        var closure = function (ch) {
            var cc = ch.charCodeAt(0);
            return ((cc >= 48 && cc <= 57) || // 0-9
                (cc >= 65 && cc <= 70) || // A-F
                (cc >= 97 && cc <= 102)); // a-f
        };
        return this.takeChar(closure);
    };
    return LingoParserStream;
}(ParserStream));

var LingoParser = /** @class */ (function () {
    function LingoParser(dictionary) {
        if (dictionary === void 0) { dictionary = new LingoDictionary({}); }
        this.dictionary = dictionary;
        this.missingTags = [];
    }
    LingoParser.prototype.parsePlural = function (pluralRules) {
        var _this = this;
        var pluralOptions = [];
        Object.keys(pluralRules).forEach(function (key) {
            var rule = key;
            var ast = _this.parse(pluralRules[rule]);
            pluralOptions.push(new OptionalFormatPattern(rule, ast));
        });
        // we are using 'num_exception' as the argument for plural_rules
        // to match the same interface as the Translate API
        var pluralRule = new ArgumentElement('num_exception', new PluralFormat(pluralOptions));
        var entries = [pluralRule];
        var root = new MessageFormatRoot(entries);
        return root;
    };
    LingoParser.prototype.parseList = function (list) {
        var _this = this;
        list.other = '';
        var options = Object.keys(list).map(function (variant) {
            var msg = list[variant];
            var ast;
            if (typeof msg === 'string') {
                ast = _this.parse(msg);
            }
            else {
                ast = _this.parsePlural(msg.plural);
            }
            return new OptionalFormatPattern(variant, ast);
        });
        var selectRule = new ArgumentElement('item', new SelectFormat(options));
        var entries = [selectRule];
        var root = new MessageFormatRoot(entries);
        return root;
    };
    LingoParser.prototype.parse = function (str) {
        var stream = new LingoParserStream(str);
        var entries = [];
        while (stream.currentChar()) {
            var entry = this.getEntry(stream);
            entries.push(entry);
        }
        var root = new MessageFormatRoot(entries);
        return root;
    };
    LingoParser.prototype.getEntry = function (stream) {
        if (stream.currentChar() === '{') {
            return this.getArgument(stream);
        }
        return this.getTextElement(stream);
    };
    LingoParser.prototype.astHasitem = function (ast, item) {
        if (ast.elements.length > 0) {
            var argElement = ast.elements[0];
            if (argElement.type === 'argumentElement') {
                var selectElement = argElement.format;
                if (selectElement && selectElement.type === 'selectFormat') {
                    return Boolean(selectElement.options.find(function (opt) {
                        return opt.type === 'optionalFormatPattern' && opt.selector === item;
                    }));
                }
            }
        }
        return false;
    };
    LingoParser.prototype.addMissingTag = function (list, item, form) {
        if (!item) {
            this.missingTags.push("".concat(list, "/").concat(form));
        }
        else {
            this.missingTags.push("".concat(list, "/").concat(item, "/").concat(form));
        }
    };
    LingoParser.prototype.getRecursiveTag = function (stream) {
        stream.expectChar('/');
        var listName = this.getIdentifier(stream);
        var arg = '';
        var itemName = '';
        var allItems = true;
        stream.expectChar('/');
        if (stream.currentChar() === '[') {
            stream.expectChar('[');
            arg = this.getIdentifier(stream);
            stream.expectChar(']');
        }
        else {
            itemName = this.getItemIdentifier(stream);
            allItems = false;
            arg = itemName;
        }
        var listForm = 'name';
        if (stream.currentChar() === '/') {
            stream.next();
            listForm = this.getIdentifier(stream);
        }
        var tagName = "".concat(listName, "/").concat(listForm);
        var listAst = this.dictionary.parse(tagName);
        if (!listAst || (itemName && !this.astHasitem(listAst, itemName))) {
            // recursive tag is missing from the dictionary
            this.addMissingTag(listName, itemName, listForm);
            return {
                formatAst: null,
                arg: arg,
                listName: listName,
                listForm: listForm,
                itemName: itemName,
                allItems: allItems,
            };
        }
        // after parsing the recursive tag, we add a pointer reference to the format member
        var firstElement = listAst
            .elements[0];
        var formatAst = firstElement.format;
        return { formatAst: formatAst, arg: arg, listName: listName, listForm: listForm };
    };
    LingoParser.prototype.getArgument = function (stream) {
        stream.expectChar('{');
        stream.skipBlank();
        var arg;
        var formatAst = null;
        var meta = undefined;
        if (stream.currentChar() === '/') {
            var result = this.getRecursiveTag(stream);
            formatAst = result.formatAst;
            arg = result.arg;
            meta = {
                recursiveTag: "".concat(result.listName, "/").concat(result.listForm),
                allItems: result.allItems,
                item: result.itemName,
            };
        }
        else {
            arg = this.getIdentifier(stream);
        }
        stream.skipBlank();
        stream.expectChar('}');
        return new ArgumentElement(arg, formatAst, meta);
    };
    LingoParser.prototype.getEscapeSequence = function (stream, specials) {
        if (specials === void 0) { specials = ['{', '\\', '}']; }
        var next = stream.currentChar();
        if (specials.indexOf(next) >= 0) {
            stream.next();
            return next;
        }
        if (next === 'u') {
            var sequence = '';
            stream.next();
            for (var i = 0; i < 4; i += 1) {
                var ch = stream.takeHexDigit();
                if (!ch) {
                    throw new ParseError(ErrorCodes.E0005, sequence + stream.currentChar());
                }
                sequence += ch;
            }
            return "\\u".concat(sequence);
        }
        return '\\';
    };
    LingoParser.prototype.getTextElement = function (stream) {
        var buffer = '';
        var ch;
        while ((ch = stream.currentChar())) {
            if (ch === '{') {
                return new MessageTextElement(buffer);
            }
            if (ch === EOL) {
                stream.next();
                stream.skipBlankInline();
                buffer += EOL;
                continue;
            }
            if (ch === '\\') {
                stream.next();
                buffer += this.getEscapeSequence(stream);
                continue;
            }
            buffer += ch;
            stream.next();
        }
        return new MessageTextElement(buffer);
    };
    LingoParser.prototype.getIdentifier = function (stream) {
        var name = stream.takeIDStart();
        return this.getItemIdentifier(stream, name);
    };
    LingoParser.prototype.getItemIdentifier = function (stream, initialString) {
        if (initialString === void 0) { initialString = ''; }
        var name = initialString;
        var ch;
        while ((ch = stream.takeIDChar())) {
            name += ch;
        }
        return name;
    };
    return LingoParser;
}());

var LingoDictionary = /** @class */ (function () {
    function LingoDictionary(dictionary, options) {
        if (options === void 0) { options = {}; }
        this._messages = __assign({}, dictionary);
        this._missingTags = [];
        this._missingRecursiveLists = new Set();
        this._options = __assign({ throwOnMissingTag: true, throwOnParseError: true }, options);
        this._errors = [];
    }
    LingoDictionary.prototype.addMissingTag = function (tagName) {
        var _this = this;
        if (Array.isArray(tagName)) {
            tagName.forEach(function (tag) {
                _this.addMissingTag(tag);
            });
            return;
        }
        if (this._options.throwOnMissingTag) {
            throw new ParseError(ErrorCodes.E0006, tagName);
        }
        var slices = tagName.split('/');
        switch (slices.length) {
            case 1: {
                var _a = __read(slices, 1), tag = _a[0];
                this._missingTags.push({ tag: tag });
                break;
            }
            case 2: {
                var _b = __read(slices, 2), list = _b[0], form = _b[1];
                this._missingTags.push({ list: list, form: form, all_items: true });
                this._missingRecursiveLists.add("".concat(list, "/").concat(form));
                break;
            }
            case 3: {
                var _c = __read(slices, 3), list = _c[0], item = _c[1], form = _c[2];
                this._missingTags.push({ list: list, item: item, form: form });
                break;
            }
        }
    };
    LingoDictionary.prototype.parse = function (tagName) {
        var parser = new LingoParser(this);
        var tag = this._messages[tagName];
        if (tag === undefined) {
            this.addMissingTag(tagName);
            return;
        }
        if (tag instanceof MessageFormatRoot) {
            return tag;
        }
        var ast;
        try {
            if (typeof tag === 'string') {
                ast = parser.parse(tag);
            }
            else if (tag.type === 'plural') {
                ast = parser.parsePlural(tag.plural);
            }
            else if (tag.type === 'list') {
                ast = parser.parseList(tag.items);
            }
            else {
                // Don't know how to parse :(
                throw new ParseError(ErrorCodes.E0007, tagName, JSON.stringify(tag));
            }
        }
        catch (err) {
            if (this._options.throwOnParseError) {
                throw err;
            }
            else if (err instanceof Error) {
                this._errors.push({
                    error: err,
                    tagName: tagName,
                    tag: tag,
                });
            }
            else {
                console.log("Could not parse error ".concat(err));
            }
            return;
        }
        if (parser.missingTags.length > 0) {
            this.addMissingTag(parser.missingTags);
        }
        this._messages[tagName] = ast;
        return ast;
    };
    LingoDictionary.prototype.parseAll = function () {
        var _this = this;
        Object.keys(this._messages).forEach(function (tagName) {
            _this.parse(tagName);
        });
        this._validate();
    };
    LingoDictionary.prototype._validate = function () {
        if (this._missingRecursiveLists.size > 0) {
            var missingRecursiveLists = Array.from(this._missingRecursiveLists);
            var message = "Missing recursive translations for ".concat(missingRecursiveLists.join(', '), ".");
            if (this._options.throwOnMissingTag) {
                throw new ParseError(ErrorCodes.E0006, message);
            }
            else {
                console.warn(message);
            }
        }
    };
    return LingoDictionary;
}());
function lingoDictionary(messages, options) {
    var dictionary = new LingoDictionary(messages, options);
    dictionary.parseAll();
    return dictionary;
}

export { ArgumentElement, ErrorCodes, LingoDictionary, LingoParser, MessageFormatRoot, MessageTextElement, OptionalFormatPattern, ParseError, PluralFormat, SelectFormat, lingoDictionary };
//# sourceMappingURL=index.es.js.map
